/**
 * Theme Store
 * Global theme state (light/dark)
 */

import { create } from 'zustand';

interface ThemeState {
  isDark: boolean;
  toggle: () => void;
  init: () => void;
}

export const useThemeStore = create<ThemeState>((set) => ({
  isDark: document.documentElement.classList.contains('dark'),

  toggle: () => {
    const html = document.documentElement;
    const isDark = html.classList.contains('dark');

    // Enable smooth transition
    html.style.transition = 'background-color 200ms, color 200ms, border-color 200ms';

    if (isDark) {
      html.classList.remove('dark');
      localStorage.setItem('tw-theme', 'light');
    } else {
      html.classList.add('dark');
      localStorage.setItem('tw-theme', 'dark');
    }

    set({ isDark: !isDark });

    // Remove transition after animation completes
    setTimeout(() => {
      html.style.transition = '';
    }, 500);
  },

  init: () => {
    const isDark = document.documentElement.classList.contains('dark');
    set({ isDark });
  },
}));
